import { Card, Descriptions } from 'antd';
import { useWorkorderDetailContext } from '../WorkorderDetailProvider';
import { complementPaymentMethodLabel } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { isAppPortocar } from '@/index';
import { useWindowSize } from '@/hooks';

export default function WorkOrderPortoBatteryPayment() {
  const {
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const { isMobile } = useWindowSize();

  if (!complement?.portoBatteryPaymentMethod || !isAppPortocar) return null;

  return (
    <Card
      title={
        <div style={{ whiteSpace: 'pre-wrap' }}>
          Dados de pagamento da bateria
        </div>
      }
      style={{ borderRadius: 10 }}
    >
      <Descriptions column={isMobile ? 1 : 3} layout="vertical">
        <Descriptions.Item
          style={{ paddingBottom: 4 }}
          contentStyle={{
            fontWeight: 600,
            paddingBottom: isMobile ? 8 : undefined,
          }}
          label="Método de pagamento"
        >
          {complementPaymentMethodLabel[complement.portoBatteryPaymentMethod]}
        </Descriptions.Item>

        <Descriptions.Item
          style={{ paddingBottom: 4 }}
          contentStyle={{
            fontWeight: 600,
            paddingBottom: isMobile ? 8 : undefined,
          }}
          label="Cód. autorização"
        >
          {complement?.portoBatteryAuthorizationCode || 'Sem dados'}
        </Descriptions.Item>

        <Descriptions.Item
          style={{ paddingBottom: 4 }}
          contentStyle={{
            fontWeight: 600,
            paddingBottom: isMobile ? 8 : undefined,
          }}
          label="Qtde. parcelas"
        >
          {complement?.portoBatteryInstallmentsQuantity
            ? `${complement.portoBatteryInstallmentsQuantity}x`
            : 'Sem dados'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
